import React from 'react';
import { ZoomIn, ZoomOut, Maximize2, LayoutList, LayoutGrid } from 'lucide-react';
import { Button } from '../ui/button';

const CanvasBottomBar = ({
  zoom, setZoom, onFitToScreen,
  pages, currentPageId,
  showPagesPanel, onTogglePagesPanel,
  onToggleGridView,
}) => {
  const currentIndex = pages.findIndex(p => p.id === currentPageId);
  const zoomPct = Math.round(zoom * 100);

  return (
    <div className="h-10 bg-white border-t flex items-center px-3 gap-2 flex-shrink-0 select-none z-10">
      <Button
        size="icon"
        variant="ghost"
        className="h-7 w-7"
        onClick={() => setZoom(z => Math.max(0.1, Math.round((z - 0.1) * 100) / 100))}
      >
        <ZoomOut className="w-3.5 h-3.5" />
      </Button>

      <input
        type="range"
        min={10}
        max={200}
        step={5}
        value={zoomPct}
        onChange={e => setZoom(Number(e.target.value) / 100)}
        className="w-28 h-1 accent-purple-600 cursor-pointer"
      />

      <Button
        size="icon"
        variant="ghost"
        className="h-7 w-7"
        onClick={() => setZoom(z => Math.min(2, Math.round((z + 0.1) * 100) / 100))}
      >
        <ZoomIn className="w-3.5 h-3.5" />
      </Button>

      <button
        onDoubleClick={() => setZoom(1)}
        className="text-xs font-medium w-11 text-center text-gray-600 hover:text-gray-900 tabular-nums"
        title="Double-click to reset to 100%"
      >
        {zoomPct}%
      </button>

      <Button size="icon" variant="ghost" className="h-7 w-7" onClick={onFitToScreen} title="Fit to screen">
        <Maximize2 className="w-3.5 h-3.5" />
      </Button>

      <div className="flex-1" />

      <span className="text-xs text-gray-500 tabular-nums font-medium">
        Page {currentIndex + 1} / {pages.length}
      </span>

      <div className="w-px h-4 bg-gray-200" />

      <Button size="icon" variant="ghost" className="h-7 w-7" onClick={onToggleGridView} title="Grid view (all pages)">
        <LayoutGrid className="w-3.5 h-3.5" />
      </Button>

      <Button
        size="icon"
        variant={showPagesPanel ? 'secondary' : 'ghost'}
        className="h-7 w-7"
        onClick={onTogglePagesPanel}
        title={showPagesPanel ? 'Hide pages' : 'Show pages'}
      >
        <LayoutList className="w-3.5 h-3.5" />
      </Button>
    </div>
  );
};

export default CanvasBottomBar;
